import axios from '../../axios'

export const getCompanies = ({name, from, limit}) => {
  return axios.get(process.env.COMPANIES_URL,
    {
      params: {name, from, limit}
    })
}



// WEBPACK FOOTER //
// ./src/api/production/companies/index.js